import React from "react";
import { useSelector } from "react-redux";
import { useLocation, Navigate } from "react-router-dom";
import { getRoutesForRole } from "./roleBasedRoutes";

export const ProtectedRoutes = (WrappedComponent, allowedRoles) => {
  const ProtectedComponent = (props) => {
    const location = useLocation();
    const userRole = useSelector((state) => state.auth.data.roleId);
    const routeAccess = getRoutesForRole(userRole);

    if (allowedRoles.includes(userRole)) {
      return <WrappedComponent {...props} />;
    }

    return (
      <Navigate
        to={routeAccess[0]?.path || "/dashboard"}
        state={{ from: location }}
        replace
      />
    );
  };

  return (props) => <ProtectedComponent {...props} />;
};
